var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificates",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    transform: "translate(0 8)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8848",
    transform: "translate(5.948 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2215",
    d: "M18.892,6.482a8.318,8.318,0,0,0-8.368,8.269,8.217,8.217,0,0,0,2.333,5.7L9.8,25.679l3.446-.7,1.107,3.3L17.5,22.892a7.976,7.976,0,0,0,2.771.011l3.139,5.373,1.109-3.3,3.445.7-3.04-5.2a8.217,8.217,0,0,0,2.335-5.726,8.318,8.318,0,0,0-8.368-8.269Zm0,2.6a5.673,5.673,0,1,1-5.74,5.672,5.707,5.707,0,0,1,5.74-5.672Z",
    transform: "translate(-9.803 -6.482)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48_2_",
    "data-name": "star_FILL0_wght400_GRAD0_opsz48 (2)",
    d: "M10.849,14.761a.269.269,0,0,1-.356.01.273.273,0,0,1-.115-.339l.662-2.146-1.7-1.218a.276.276,0,0,1-.115-.334.272.272,0,0,1,.286-.2h2.115l.672-2.236a.273.273,0,0,1,.116-.165.308.308,0,0,1,.351,0,.273.273,0,0,1,.115.165l.671,2.236H15.66a.272.272,0,0,1,.286.2.276.276,0,0,1-.115.334l-1.7,1.218.662,2.146a.273.273,0,0,1-.115.339.269.269,0,0,1-.356-.01l-1.734-1.317Z",
    transform: "translate(-3.494 -3.3)",
    fill: "rgba(0,0,0,0.6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/Certificates.8dd0ff733b37c87f4c8c4e6d1e8eaa93.svg";
export { ForwardRef as ReactComponent };